import React from 'react';
import { connect } from 'react-redux';
import { InputMoney } from '@nerdwallet/currency';
import num from '@nerdwallet/nw-client-lib/num';

import { REFINANCE } from '../../../lib/analytics-constants';
import { validationsSelector } from '../../../lib/selectors';
import {
  manualInputsSelector,
  inputsSelector,
  outputsSelector,
} from '../../../lib/selectors/refinance-calculator-selectors';
import { RefinanceInput, inputOnChange } from '../../../lib/utils';

type OnChangeEvent = React.ChangeEvent<HTMLInputElement>;

const RefinanceClosingCosts: React.FC<RefinanceInput> = ({
  manualInputs,
  dispatch,
  analytics,
  validations,
  label = '',
  tooltip = '',
  className = '',
  outputs,
}) => {
  const value = manualInputs?.newMortgageClosingCosts;
  const placeholder = num.formatCurrency(
    outputs?.details?.refinanceLoan?.closingCosts
  );
  const errorMessage = validations?.newMortgageClosingCosts?.[0];
  const error = Boolean(errorMessage);
  const analyticsEnabled = analytics && analytics?.enabled;
  const bedrockAnalytics =
    analyticsEnabled && analytics?.payload?.bedrock?.eventType;

  const onInputChange = (e: OnChangeEvent) => {
    let bedrock;
    if (bedrockAnalytics) {
      const bedrockProps = analytics?.payload?.bedrock;
      bedrock = {
        ...bedrockProps,
        valueFieldName: 'value_i',
      };
    }

    inputOnChange({
      event: e,
      dispatch,
      bedrock,
      fieldName: 'newMortgageClosingCosts',
      calculator: REFINANCE,
      inputType: 'currency',
    });
  };

  return (
    <InputMoney
      label={label}
      value={value}
      placeholder={placeholder}
      error={error}
      errorMessage={errorMessage}
      onChange={onInputChange}
      tooltip={tooltip}
      className={className}
    />
  );
};

const mapStateToProps = (state) => ({
  manualInputs: manualInputsSelector(state),
  inputs: inputsSelector(state),
  validations: validationsSelector(state),
  outputs: outputsSelector(state),
});

export default connect(mapStateToProps)(RefinanceClosingCosts);
